import { PhDeviceMobile } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

import { getBrandHasApp } from '../../composables/useBrandHasApp'
import {
  type CampaignResource,
  type GetTheAppButtonsSection,
  type GetTheAppButtonsSectionCreate,
  type GetTheAppButtonsSectionUpdate,
} from '../../types'
import { emailBlockMethods } from '../common/methods'

import { createGetTheAppButtonsData } from './methods/createGetTheAppButtonsData'
import GetTheAppButtonsPreview from './preview/GetTheAppButtonsPreview.vue'

const i18n = i18nPlugin.global

const GET_THE_APP_BUTTONS_FEATURE_FLAG = 'hermes.getTheAppButtonsInEmailBuilder'

export const GetTheAppButtonsBlockModule: BuilderBlockModule<
  GetTheAppButtonsSection,
  GetTheAppButtonsSectionCreate,
  GetTheAppButtonsSectionUpdate,
  CampaignResource
> = {
  canAdd: (ctx) =>
    useFeatureFlags().isEnabled(GET_THE_APP_BUTTONS_FEATURE_FLAG) &&
    getBrandHasApp(ctx.resource?.brandId) === true,
  canDelete: true,
  canReorderDown: true,
  canReorderUp: true,
  createData: createGetTheAppButtonsData,
  meta: [
    {
      icon: PhDeviceMobile,
      key: 'get-the-app-buttons',
      label: i18n.t('email-builder.blocks.get-the-app-buttons'),
      sort: 6,
    },
  ],
  methods: emailBlockMethods,
  preview: GetTheAppButtonsPreview,
}
